
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payments/plans/promo-special/annual-lt-b",
      function () {
        return require("private-next-pages/payments/plans/promo-special/annual-lt-b/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payments/plans/promo-special/annual-lt-b"])
      });
    }
  